<template>
  <div>
    <HvhModal :value="true" :title="title" @input="$emit('input', false)">
      <DataTableAsync :data="filteredGroups" v-model="tableState" :length="count" @input="tableState = $event">
        <template #menu>
          <v-btn flat class="hvh-btn hvh-btn--secondary" @click="newGroup = ''">Add</v-btn>
        </template>
        <template #head>
          <tr>
            <th>Group Name</th>
            <th>Permissions</th>
            <th />
          </tr>
        </template>
        <template #body="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td class="link text-center" @click="manageGroup = item">Modify</td>
            <td class="link text-center" @click="deleteObject(item)">Delete</td>
          </tr>
        </template>
      </DataTableAsync>
      <Loader v-if="!groups || isSaving" />
    </HvhModal>

    <HvhModal :value="true" :title="title" @input="newGroup = null" v-if="newGroup != null">
      <v-text-field v-model="newGroup" label="Group Name" outline hide-details />
      <template v-slot:actions>
        <v-btn flat="flat" @click="newGroup = null">Cancel</v-btn>
        <v-btn flat="flat" outline @click="addGroup">Add</v-btn>
      </template>
      <Loader v-if="isSaving" />
    </HvhModal>

    <ManagePermissions :group="manageGroup" @input="manageGroup = null" v-if="manageGroup" />
  </div>
</template>

<script>
import axios from '../../axios';
import { errorDebug } from '../../libraries/common';
import DataTableAsync from '../common/dataTable/DataTableAsync.vue';
import HvhModal from '../common/modal/HvhModal.vue'
import ManagePermissions from './ManagePermissions.vue';
export default {
  components: { HvhModal, DataTableAsync, ManagePermissions, },
  props: ['title', 'id', 'type',],
  data() {
    return {
      groups: null,
      tableState: { page: 1, perPage: 50 },
      count: 50,
      newGroup: null,
      manageGroup: null,
      isSaving: false,
    };
  },
  computed: {
    filteredGroups() {
      return (this.groups || [])
        .filter(f => !this.tableState.searchText || f.name.toLowerCase().includes(this.tableState.searchText));
    },
  },
  methods: {
    getData() {
      axios.get('/Permissions/Group', { params: { id: this.id, type: this.type } })
        .then(response => this.groups = response.data);
    },
    addGroup() {
      this.isSaving = true;
      axios.post('/Permissions/Group', { name: this.newGroup, objectId: this.id, type: this.type })
        .then(response => axios.post(`/Permissions/Group/${response.data.id}`, this.id))
        .then(response => {
          this.groups = [...this.groups, response.data];
          this.newGroup = null;
        })
        .catch(errorDebug)
        .then(() => this.isSaving = false);
    },
    deleteObject(group) {
      this.isSaving = true;
      axios.delete(`/Permissions/Group/${group.id}/${this.id}`)
        .then(() => this.groups = this.groups.filter(f => f.id !== group.id))
        .catch(errorDebug)
        .then(() => this.isSaving = false);
    },
    // save() {
    //   debugger;
    //   axios.post('/Permissions/Group', { name: this.newGroup })
    //     .then(response => this.groups = [...this.groups, response.data]);
    // },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisManageGroups'] = this;
    this.getData();
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: #002f6c;
  text-decoration: underline #002f6c;
  cursor: pointer;
}
</style>